export class Sheet {
  grade: number | null = 0
  name: string = ""
  curriculum_id: number | null = 0
  score_positions_completed: boolean | null = null
  question_image_completed: boolean | null = null
}
